<script lang="ts">
	import Media from "@components/common/Media.svelte";
	import Slideshow from "@components/common/Slideshow.svelte";
	import type { ContentType } from "@core/schema/ContentType.js";
	import type { ContentBlockComponentProps } from "./ContentBlockComponentProps.js";

	const id = $props.id();
	const { data, lightboxId = id }: ContentBlockComponentProps<ContentType.Gallery> = $props();
</script>

<Slideshow
	flowDirection="left"
	class="gap-4 bg-white py-4 relative rounded-2xl border-white border-x-[1rem] max-w-[calc(100vw-2rem)] mx-auto"
>
	{#each data.images as image, index (index)}
		<Media
			source={image}
			class="object-cover rounded-lg size-full"
			alt={image.title ?? ""}
			height={300}
			width={400}
			sourcesets={{
				"<lg": [300, 400],
				">lg": [300, 400],
			}}
			lightbox={lightboxId}
			wrapperClass="max-w-[18.75rem] lg:max-w-[25rem] w-full block aspect-[4/3] h-[14rem] lg:h-[18.75rem]"
		/>
	{/each}
</Slideshow>
